module.exports = __webpack_public_path__ + "61f18352fc814750a22c2d31e40b9cbc.png";